module.exports = __webpack_public_path__ + "a69f3714fbf8a5ceaeda0ab93e3719aa.png";